import { Loader } from '../Widgets';
import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { Company, Party, SUPPORT_MOBILE_NUMBER } from 'service';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAddressBook, faBasketShopping, faBuildingColumns, faCartPlus, faChartLine, faClipboardList, faCopy, faCreditCard, faFileInvoiceDollar, faHeadset, faListAlt, faMoneyCheckAlt, faPhone, faPhoneVolume, faQuestionCircle, faReceipt, faShippingFast, faShoppingBag, faShoppingCart, faTags, faWallet } from '@fortawesome/free-solid-svg-icons';
import ArthaGateway from 'service/ArthaGateway';
import { ACCOUNTS_PHONENUMBER, app_version, clearCache, DISPATCH_PHONENUMBER, ENQUIRY1_PHONENUMBER, ENQUIRY2_PHONENUMBER, ORDERS_PHONENUMBER } from 'service/Utils';

export const Dashboard = () => {
    const user = useSelector((state: RootState) => state.appdata);
    const [party, setParty] = useState<Party>();
    const [balance, setBalance] = useState<number>(0);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [isBalanceLoading, setIsBalanceLoading] = useState<boolean>(true);
    const [company, setCompany] = useState<Company>();

    useEffect(() => {
        if (user.profile) {
            setParty(user.profile.profile);
            setIsLoading(false);
        }
    }, [user]);

    useEffect(() => {
        if (!party) {
            return;
        }
        ArthaGateway
            .getBalance(party.accountId)
            .then((data) => {
                let totalBalance = data.reduce((sum, d) => sum + d.balance, 0);
                setBalance(totalBalance);
                setIsBalanceLoading(false);
                fetchCompanyDetails();
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
                setIsBalanceLoading(false)
            });
    }, [party]);

    const fetchCompanyDetails = () => {
        const cachedCompany = sessionStorage.getItem("company");
        if (cachedCompany) {
            setCompany(JSON.parse(cachedCompany));
        }
        else {
            ArthaGateway
                .getCompany(1)
                .then((data) => {
                    setCompany(data);
                    sessionStorage.setItem("company", JSON.stringify(data));
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    };

    const currencyFormat = (value) =>
        new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR'
        }).format(value);

    return (
        <>
            <div className="page-dashboard">
                <div className='page-header bg-primary mb-2 pb-2'>
                    Welcome,
                    <h3>{party?.name}</h3>
                    <p>{party?.gstin}</p>
                </div>
                {isLoading &&
                    <Loader />
                }
                {!isLoading &&
                    <>
                        <div className='card mb-2'>
                            <div className="card-body p-2 bg-danger text-white rounded-2">
                                <div className="card-title">Your balance is</div>
                                <p className="card-text float-start">
                                    <div>
                                        {isBalanceLoading &&
                                            <div className="spinner-border" role="status">
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                        }
                                        {!isBalanceLoading &&
                                            <h2 style={{ fontWeight: "bolder" }}>{currencyFormat(balance)}</h2>
                                        }
                                    </div>
                                    {!isBalanceLoading && balance < 0 &&
                                        <span> (You have credit of {currencyFormat(-balance)})</span>
                                    }
                                    {balance === 0 &&
                                        <span> (You have no dues)</span>
                                    }
                                </p>
                                <NavLink to="/payment" className="btn btn-dark float-end">
                                    <FontAwesomeIcon icon={faCreditCard} style={{ width: "auto" }} />
                                    &nbsp; UPI Pay
                                </NavLink>
                            </div>
                        </div>
                        <div className="row tiles">
                            <div className="col-6 col-md-4 col-md-3">
                                <NavLink className="card mb-2" to="/products">
                                    <div className="card-img-top d-flex justify-content-center align-items-center" style={{ height: "60px" }}>
                                        <FontAwesomeIcon icon={faTags} size="2x" />
                                    </div>
                                    <div className="card-body text-center p-1 font-weight-bold">
                                        <h5 className="card-title">Products</h5>
                                    </div>
                                </NavLink>
                            </div>
                            <div className="col-6 col-md-4 col-md-3">
                                <NavLink className="card mb-2" to="/business">
                                    <div className="card-img-top d-flex justify-content-center align-items-center" style={{ height: "60px" }}>
                                        <FontAwesomeIcon icon={faListAlt} size="2x" />
                                    </div>
                                    <div className="card-body text-center p-1 font-weight-bold">
                                        <h5 className="card-title">Statement</h5>
                                    </div>
                                </NavLink>
                            </div>
                            <div className="col-6 col-md-4 col-md-3">
                                <NavLink className="card mb-2" to="/bank">
                                    <div className="card-img-top d-flex justify-content-center align-items-center" style={{ height: "60px" }}>
                                        <FontAwesomeIcon icon={faBuildingColumns} size="2x" />
                                    </div>
                                    <div className="card-body text-center p-1 font-weight-bold">
                                        <h5 className="card-title">Bank Details</h5>
                                    </div>
                                </NavLink>
                            </div>
                            <div className="col-6 col-md-4 col-md-3">
                                <NavLink className="card mb-2" to="/contact">
                                    <div className="card-img-top d-flex justify-content-center align-items-center" style={{ height: "60px" }}>
                                        <FontAwesomeIcon icon={faAddressBook} size="2x" />
                                    </div>
                                    <div className="card-body text-center p-1 font-weight-bold">
                                        <h5 className="card-title">Contact Details</h5>
                                    </div>
                                </NavLink>
                            </div>
                            <div className="col-6 col-md-4 col-md-3">
                                <NavLink className="card mb-2" to="/order/new">
                                    <div className="card-img-top d-flex justify-content-center align-items-center" style={{ height: "60px" }}>
                                        <FontAwesomeIcon icon={faCartPlus} size="2x" />
                                    </div>
                                    <div className="card-body text-center p-1 font-weight-bold">
                                        <h5 className="card-title">New Order</h5>
                                    </div>
                                </NavLink>
                            </div>
                        </div>
                        <div className="row tiles">
                            <div className="col-6 col-md-4 col-md-3">
                                <NavLink className="card mb-2" to="/invoice">
                                    <div className="card-img-top d-flex justify-content-center align-items-center" style={{ height: "60px" }}>
                                        <FontAwesomeIcon icon={faChartLine} size="2x" />
                                    </div>
                                    <div className="card-body text-center p-1 font-weight-bold">
                                        <h5 className="card-title">Sales</h5>
                                    </div>
                                </NavLink>
                            </div>
                            <div className="col-6 col-md-4 col-md-3">
                                <NavLink className="card mb-2" to="/order">
                                    <div className="card-img-top d-flex justify-content-center align-items-center" style={{ height: "60px" }}>
                                        <FontAwesomeIcon icon={faShoppingCart} size="2x" />
                                    </div>
                                    <div className="card-body text-center p-1 font-weight-bold">
                                        <h5 className="card-title">Orders</h5>
                                    </div>
                                </NavLink>
                            </div>
                            <div className="col-6 col-md-4 col-md-3">
                                <NavLink className="card mb-2" to="/receipt">
                                    <div className="card-img-top d-flex justify-content-center align-items-center" style={{ height: "60px" }}>
                                        <FontAwesomeIcon icon={faReceipt} size="2x" />
                                    </div>
                                    <div className="card-body text-center p-1 font-weight-bold">
                                        <h5 className="card-title">Receipts</h5>
                                    </div>
                                </NavLink>
                            </div>
                            <div className="col-6 col-md-4 col-md-3">
                                <NavLink className="card mb-2" to="/bankCheques">
                                    <div className="card-img-top d-flex justify-content-center align-items-center" style={{ height: "60px" }}>
                                        <FontAwesomeIcon icon={faMoneyCheckAlt} size="2x" />
                                    </div>
                                    <div className="card-body text-center p-1 font-weight-bold">
                                        <h5 className="card-title">Bank Cheques</h5>
                                    </div>
                                </NavLink>
                            </div>
                        </div>
                        
                        <div style={{ position: "relative", height: 50 }}>
                            <div className='version-number'>
                                <div className="btn btn-sm bg-dark" style={{ marginBottom: 10, color: "#fff", float: "left" }} onClick={clearCache}>Update to latest version</div>
                                <span style={{ float: "right" }} >{app_version}</span>
                            </div>
                        </div>
                    </>
                }
            </div>
        </>
    );
};